import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const AlipayResultMob = () => {
  return <CommonResult />;
};

export default AlipayResultMob;
